import SvgIcon from '@components/SvgIcon';
import styled from 'styled-components';

export const IconPure = styled(SvgIcon).attrs({
  children: ({ color }: { color: string }) => (
    <path
      d="M4 2a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3H4Zm-2 9V5q0-.828.586-1.414T4 3h8q.828 0 1.414.586T14 5v6q0 .828-.586 1.414T12 13H4q-.828 0-1.414-.586T2 11Zm2-7a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H4Z"
      fillRule="evenodd"
      fill={color}
    />
  ),
})``;

export const IconGradient = styled(SvgIcon).attrs({
  children: ({ color }: { color: string }) => (
    <>
      <defs>
        <linearGradient
          x1=".5"
          y1="0"
          x2=".5"
          y2="1"
          id="prefix9FEOxDZJx7e3Ae5ux7TqBa"
        >
          <stop offset="0%" stopColor="#FFF" stopOpacity="0" />
          <stop offset="100%" stopColor="#FFF" stopOpacity=".6" />
        </linearGradient>
      </defs>
      <g>
        <path
          d="M1 5a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3V5Zm1 0v6q0 .828.586 1.414T4 13h8q.828 0 1.414-.586T14 11V5q0-.828-.586-1.414T12 3H4q-.828 0-1.414.586T2 5Z"
          fillRule="evenodd"
          fill={color}
        />
        <rect
          x="3"
          y="4"
          width="10"
          height="8"
          rx="1"
          fill="url(#prefix9FEOxDZJx7e3Ae5ux7TqBa)"
        />
      </g>
    </>
  ),
})``;
